import { reportConstants } from '../../constants/reports';
import {
	FilterMapType,
	GRColumsFormatType,
	MergeRowsMapType,
	NoSubtotalItem,
	SubtotalLabelItem,
} from './types/partners-report-types';

const gamblingReportMap = [
	{ label: reportConstants.REPORT_SESSIONS, key: reportConstants.COLUMN_SESSIONS },
	{ label: reportConstants.REPORT_UAP, key: reportConstants.COLUMN_UAP },
	{ label: reportConstants.REPORT_ROUNDS, key: reportConstants.COLUMN_NRHANDS },
	{ label: reportConstants.REPORT_CURRENCY, key: reportConstants.COLUMN_CURRENCY },
	{ label: reportConstants.REPORT_BET, key: reportConstants.COLUMN_BET_AMOUNT },
	{ label: reportConstants.REPORT_WIN, key: reportConstants.COLUMN_LIFETIME_WIN },
	{ label: reportConstants.REPORT_BONUS_BET, key: reportConstants.COLUMN_BONUS_BET },
	{ label: reportConstants.REPORT_BONUS_WIN, key: reportConstants.COLUMN_BONUS_WIN },
	{ label: reportConstants.REPORT_GGR, key: reportConstants.COLUMN_GGR },
	{ label: reportConstants.REPORT_GGR_EUR, key: reportConstants.COLUMN_GGR_EUR },
	{ label: reportConstants.REPORT_RATE, key: reportConstants.COLUMN_RATE },
	{ label: reportConstants.REPORT_BINGO_FEE, key: reportConstants.COLUMN_BINGO_FEE },
	{ label: reportConstants.REPORT_JP_CONTRIBUTION, key: reportConstants.COLUMN_JP_CONTRIBUTION },
	{ label: reportConstants.REPORT_JP_WIN, key: reportConstants.COLUMN_JP_WIN },
	{ label: reportConstants.REPORT_RAKE, key: reportConstants.COLUMN_RAKE },
];

const partnersColums = [
	{ label: reportConstants.REPORT_PARTNER, key: reportConstants.COLUMN_PARTNER },
	{ label: reportConstants.REPORT_PARTNER_ID, key: reportConstants.COLUMN_PARTNER_ID },
	{ label: reportConstants.REPORT_SKIN, key: reportConstants.COLUMN_SKIN },
	{ label: reportConstants.REPORT_SKIN_ID, key: reportConstants.COLUMN_SKIN_ID },
];

const gamesColumns = [
	{ label: reportConstants.REPORT_GAME, key: reportConstants.COLUMN_GAME },
	{ label: reportConstants.REPORT_GAME_ID, key: reportConstants.COLUMN_GAME_ID },
];

const countriesColumns = [{ label: reportConstants.REPORT_COUNTRY, key: reportConstants.COLUMN_COUNTRY }];
const devicesColumns = [{ label: reportConstants.REPORT_DEVICE, key: reportConstants.COLUMN_DEVICE }];
const categoryColumns = [{ label: reportConstants.REPORT_CATEGORIES, key: reportConstants.COLUMN_CATEGORY }];
const providersColumns = [{ label: reportConstants.REPORT_PROVIDER, key: reportConstants.COLUMN_PROVIDER }];

const allFieldsMap = [
	...gamblingReportMap,
	...partnersColums,
	...devicesColumns,
	...providersColumns,
	...countriesColumns,
	...categoryColumns,
	...gamesColumns,
];

const columnFormatter: GRColumsFormatType = {
	currency: 'value',
	partner: 'value',
	skin: 'value',
	skin_id: 'value_numeric',
	partner_id: 'value_numeric',
	game: 'value',
	game_id: 'value_numeric',
	country: 'value',
	device: 'value',
	category: 'value',
	provider: 'value',
	nrhands: 'number',
	bet: 'cents',
	win: 'cents',
	bonus_bet: 'cents',
	bonus_win: 'cents',
	ggr: 'cents',
	ggr_eur: 'cents',
	rate: 'number',
	bingo_fee: 'cents',
	jp_contribution: 'cents',
	jp_win: 'cents',
	sessions: 'number',
	uap: 'number',
	rake: 'cents',
};

const filtersMap: FilterMapType = {
	partner_ids: 'partners',
	category_ids: 'gameCategories',
	game_ids: 'games',
	game_provider_ids: 'providers',
	countries: 'countries',
	devices: 'devices',
};

const mergeRowMap: MergeRowsMapType = {
	game_ids: 'game_id',
	partner_ids: 'skin_id',
	category_ids: 'category',
	game_provider_ids: 'provider',
	countries: 'country',
	devices: 'device',
};

const noSubtotalItems: NoSubtotalItem[] = ['skin', 'skin_id', 'partner_id', 'game_name', 'game_id', 'rate'];
const subtotalLabel: SubtotalLabelItem[] = ['provider', 'partner', 'country', 'category', 'device', 'game_name'];
const notMergableColums: (SubtotalLabelItem | NoSubtotalItem)[] = [...noSubtotalItems, ...subtotalLabel];

export {
	gamblingReportMap,
	columnFormatter,
	filtersMap,
	partnersColums,
	gamesColumns,
	countriesColumns,
	devicesColumns,
	categoryColumns,
	providersColumns,
	allFieldsMap,
	noSubtotalItems,
	subtotalLabel,
	mergeRowMap,
	notMergableColums,
};
